import { render, staticRenderFns } from "./ComboDetail.vue?vue&type=template&id=28efd69a&lang=html"
import script from "./ComboDetail.vue?vue&type=script&lang=js"
export * from "./ComboDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports